import { useEffect, useState } from 'react';
import { useCallback } from 'react';

import uuid4 from 'uuid4';

import { Item as ItemType } from '../Types';

const useItems = () => {
    const [items, setItems] = useState<ItemType[]>([]);

    const getNewItem = useCallback(() => {
        return { id: uuid4(), plastic: '', alternative: '', amount: 0 };
    }, []);

    const addItem = useCallback(() => {
        setItems(oldItems => {
            return [...oldItems, getNewItem()];
        });
    }, [getNewItem]);

    const removeItem = useCallback((itemId: string) => {
        setItems(oldItems => {
            return [...oldItems.filter(i => i.id !== itemId)];
        });
    }, []);

    const updateItem = useCallback((itemId: string, key: keyof ItemType, value: string | number) => {
        setItems((oldItems): ItemType[] => {
            const itemIndex = oldItems.findIndex(i => i.id === itemId);

            if (itemIndex === undefined) return oldItems;

            const item = oldItems[itemIndex];

            // @ts-ignore
            item[key] = value;

            const clonedItems = [...oldItems];
            clonedItems[itemIndex] = item;

            return clonedItems;
        });
    }, []);

    useEffect(() => {
        if (items.length === 0) {
            setItems((oldItems: ItemType[]) => {
                return [...oldItems, getNewItem()];
            });
        }
    }, [getNewItem, items]);

    return {
        items,
        addItem,
        removeItem,
        updateItem
    };
};

export default useItems;
